/* eslint-disable no-console */
import { Injectable } from '@angular/core';
import { AbstractControl, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { FormControlBase, ITFormControlType } from '../models/form-control-base';

@Injectable()
export class FormBuilderService {
	public constructor() {}
	public buildFormGroup(dynamicformControls: FormControlBase<ITFormControlType>[]): UntypedFormGroup {
		const group: { [key: string]: AbstractControl } = {};
		dynamicformControls.forEach((dynamicFormControl) => {
			//console.log('form builder', dynamicFormControl);
			group[dynamicFormControl.key] = new FormControl(
				dynamicFormControl.value ?? '',
				dynamicFormControl.validators
					? Validators.compose(dynamicFormControl.validators[dynamicFormControl.key])
					: null,
				dynamicFormControl.asyncValidators &&
				dynamicFormControl.asyncValidators[dynamicFormControl.key].length !== 0
					? dynamicFormControl.asyncValidators[dynamicFormControl.key]
					: null
			);
		});

		return new UntypedFormGroup(group);
	}
}
